export default __webpack_public_path__ + "static/media/close.2e6603ca.svg";